import { FeaturePublishedState, Id, ProjectFeature, ProjectFeatureStatus, } from "@supernova-studio/model";
import { DTOThreadMessageCreateInput } from "../threads";
import { DTOForgeSectionItemMoveInput } from "./project-section";
import z from "zod";
export const DTOFeaturePublishedStateUpdateInput = FeaturePublishedState.pick({
    iterationId: true,
    hideSupernovaUI: true,
    visibility: true,
});
export const DTOForgeProjectFeature = ProjectFeature;
export const DTOForgeProjectPublishedFeature = z.object({
    featureName: z.string(),
    iterationName: z.string(),
    hideSupernovaUI: z.boolean(),
    thumbnailUrl: z.string().optional(),
    staticPreviewUrl: z.string().optional(),
    // These are only included when authenticated user has access to the project (for both public & private published features)
    projectId: z.string().optional(),
    projectName: z.string().optional(),
    workspaceId: z.string().optional(),
});
export const DTOForgeProjectPublishedFeatureGetResponse = z.object({
    publishedFeature: DTOForgeProjectPublishedFeature,
});
export const DTOForgeProjectFeatureListResponse = z.object({
    features: DTOForgeProjectFeature.array(),
});
export const DTOForgeProjectFeatureGetResponse = z.object({
    feature: DTOForgeProjectFeature,
});
export const DTOForgeProjectFeatureCreateInput = z.object({
    id: Id,
    name: z.string().optional(),
    description: z.string(),
    sectionId: Id.optional(),
    afterFeatureId: Id.nullable().optional(),
    initialMessage: DTOThreadMessageCreateInput,
});
export const DTOForgeProjectFeatureUpdateInput = z.object({
    id: Id,
    name: z.string().optional(),
    description: z.string().optional(),
    isArchived: z.boolean().optional(),
    status: ProjectFeatureStatus.optional(),
    /**
     * Sending null will result in feature unpublish
     */
    publishedState: DTOFeaturePublishedStateUpdateInput.nullish(),
});
export const DTOForgeProjectFeatureDeleteInput = z.object({
    id: Id,
});
export const DTOForgeProjectFeatureGetByIdParam = z.object({
    id: Id,
});
export const DTOFeatureArtifactListQuery = z.object({
    messageId: z.string().optional(),
    iterationId: z.string().optional(),
});
export const DTOForgeProjectFeatureMoveInput = DTOForgeSectionItemMoveInput;
export const DTOForgeProjectFeatureForkInput = z.object({
    id: Id,
    sourceFeatureId: Id,
    sourceIterationId: Id.optional(),
});
